import { render, staticRenderFns } from "./IPQCQrcodes.vue?vue&type=template&id=2dddb222&scoped=true"
import script from "./IPQCQrcodes.vue?vue&type=script&lang=js"
export * from "./IPQCQrcodes.vue?vue&type=script&lang=js"
import style0 from "./IPQCQrcodes.vue?vue&type=style&index=0&id=2dddb222&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dddb222",
  null
  
)

export default component.exports